"use client";

import React from "react";

const Comparison = () => {
  return (
    <section className="py-16 border-b border-gray-800 bg-black text-white">
      <div className="max-w-6xl mx-auto px-4">
        <h2 className="text-3xl font-semibold text-center mb-12">
          Why Choose a Generic Boilerplate When You Can Have Peerquik?
        </h2>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
          {[
            { icon: "🏨", text: "Listings for B2C Marketplaces" },
            { icon: "🏠", text: "Buyer & Seller Reviews" },
            { icon: "🛒", text: "B2C & P2P Transaction System" },
            { icon: "✨", text: "Seller Dashboard for B2C Apps" },
            { icon: "📦", text: "Powerful Marketplace Search" },
            { icon: "🎥", text: "Flexible Subscription Models" },
          ].map((item, i) => (
            <div key={i} className="flex flex-col items-center text-center">
              <div className="h-16 w-16 flex items-center justify-center mb-3 rounded-full bg-gray-200 text-cyan-500">
                <span className="text-3xl">{item.icon}</span>
              </div>
              <p className="text-sm sm:text-md text-white font-semibold">{item.text}</p>
            </div>
          ))}
        </div>
        <p className="text-center text-sm text-gray-400 mt-8">
          Unlike generic Next.js boilerplates, Peerquik is tailored for B2C and P2P marketplaces, with multi-user auth and scalable features to launch fast.
        </p>
      </div>
    </section>
  );
};

export default Comparison;